import { useState } from "react";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";

export const NewThreadDialog = ({ categories = [], onCreated }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ title: "", body: "", category: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!form.category) return toast.error("Pick a category");
    setBusy(true);
    try {
      await api.post("/threads", form);
      toast.success("Posted to the board");
      setForm({ title: "", body: "", category: "" });
      setOpen(false);
      onCreated?.();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <>
      <button data-testid="community-new-thread-button" onClick={() => setOpen(true)} className="inline-flex items-center gap-2 rounded-full bg-stone-900 px-6 py-3 text-sm text-white transition-colors hover:bg-pink-600">
        <Plus className="h-4 w-4" /> Ask or share a tip
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="new-thread-dialog" className="max-w-lg rounded-2xl bg-white p-8">
          <DialogHeader><DialogTitle className="font-serif text-2xl">New post</DialogTitle></DialogHeader>
          <form onSubmit={submit} className="space-y-4">
            <Select value={form.category} onValueChange={(v) => setForm({ ...form, category: v })}>
              <SelectTrigger data-testid="new-thread-category" className="rounded-xl"><SelectValue placeholder="Category" /></SelectTrigger>
              <SelectContent>{categories.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
            </Select>
            <Input data-testid="new-thread-title" required minLength={3} placeholder="Title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="rounded-xl" />
            <Textarea data-testid="new-thread-body" required minLength={3} rows={6} placeholder="Share the details…" value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} className="rounded-xl" />
            <button data-testid="new-thread-submit" disabled={busy} className="ig-gradient w-full rounded-full py-3 text-sm font-medium text-white disabled:opacity-60">{busy ? "Posting…" : "Post"}</button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
